export const validateFile = (
  filesArray: Array<File>,
  setErrorMessage: Function,
  files: Array<File>,
  maxFileUpload?: number,
  maxFileSizeUpload?: number,
) => {
  setErrorMessage("");

  if (maxFileUpload && filesArray.length > maxFileUpload ||
    maxFileUpload && files.length >= maxFileUpload) {
    setErrorMessage(`Você só tem permissão para fazer upload de no máximo
      ${maxFileUpload} arquivos.`);
    return false;
  }

  const totalSizeFile = filesArray.reduce((total, value) => {
    return total + value.size;
  }, 0);

  if (maxFileSizeUpload && totalSizeFile > maxFileSizeUpload) {
    const formattedSize = formatFileSize(maxFileSizeUpload, 0);

    setErrorMessage(`Tamanho máximo de upload de arquivos: ${formattedSize}.`);
    return false;
  }

  return true;
};

const formatFileSize = (bytes: number, decimalPoint?: number) => {
  const k = 1000,
    point = decimalPoint || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB'],
    logarithm = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, logarithm))
    .toFixed(point)) + ' ' + sizes[logarithm];
};
